module.exports = __webpack_public_path__ + "s/img/Chill_M_3.0aabc4aa.jpg";